export default __webpack_public_path__ + "static/media/her2.05be40b5.svg";